import { render, staticRenderFns } from "./AdminAffiliatePromotionsListPage.vue?vue&type=template&id=d24da8e2&scoped=true"
import script from "./AdminAffiliatePromotionsListPage.vue?vue&type=script&lang=js"
export * from "./AdminAffiliatePromotionsListPage.vue?vue&type=script&lang=js"
import style0 from "./AdminAffiliatePromotionsListPage.vue?vue&type=style&index=0&id=d24da8e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24da8e2",
  null
  
)

export default component.exports